import styled from 'styled-components'

const PERC_FAR_FROM_CAR = 50

interface Trct_UrtoTableCellProps {
    isSelected?: boolean;
    isMainImpactPoint?: boolean
    disabled?: boolean;
}

export const Trct_CarUrtoContainer = styled.div`
    position: relative;
    display: table;
    height: 424px;
    width: 280px;
    margin-bottom: 16px;
`

export const Trct_UrtoBkImg = styled.img`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 121px;
`

export const Trct_UrtoTable = styled.div`
    height: 424px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    flex: 1;
    border-spacing: 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
`

export const Trct_UrtoTableCell = styled.div<Trct_UrtoTableCellProps>`
    position: relative;
    overflow-x: hidden;
    overflow-y: hidden;
    position: relative;
    /* border: 1px dashed #777; */
    padding: 4px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: ${props => props.isSelected ? 'rgba(255, 247, 0, 0.3)' : 'transparent'}; */
    pointer-events: ${props => props.disabled && 'none'};

    li{
        width: unset;
        height: unset;
    }

    &.excluded-position {
        pointer-events: none;
    }
`

export const Trct_BtnZoneSelector = styled.button<Trct_UrtoTableCellProps>`
    cursor: pointer;
    outline: none;
    background-color: ${props => {
        if (props.isSelected) {
            return props.isMainImpactPoint ? '#C4151C' : '#0F3250';
        }
        return '#F1F1F1'
    }};
    width: 48px;
    height: 48px;
    outline: none;
    border: none;
    border-radius: 8px;
    transition: background-color 0.2s ease-in-out;

    &.TOP-LEFT {
        transform: ${`translateY(${PERC_FAR_FROM_CAR / 2.5}%) rotate(-45deg)`};
    }

    &.TOP-CENTER {
        transform: ${`translateY(-${PERC_FAR_FROM_CAR * 1.2}%)`};
    }

    &.TOP-RIGHT {
        transform: ${`translateY(${PERC_FAR_FROM_CAR / 2.5}%) rotate(45deg)`};
    }

    &.CENTER-LEFT {
        transform: ${`translateX(${-PERC_FAR_FROM_CAR / 1.5}%) rotate(-90deg)`};
    }

    &.CENTER-RIGHT {
        transform: ${`translateX(${PERC_FAR_FROM_CAR / 1.5}%) rotate(90deg)`};
    }

    &.BOTTOM-LEFT {
        transform: ${`translateY(${-PERC_FAR_FROM_CAR / 2.5}%) rotate(-135deg)`};
    }

    &.BOTTOM-CENTER {
        transform: ${`translateY(${PERC_FAR_FROM_CAR * 1.2}%) rotate(180deg)`};
    }

    &.BOTTOM-RIGHT {
        transform: ${`translateY(${-PERC_FAR_FROM_CAR / 2.5}%) rotate(135deg)`};
    }

    &:disabled {
        background-color: #C4151C;
        pointer-events: none;
        opacity: 0.6;
    }
`
